import React, { useReducer, useEffect } from 'react';
import { Modal, Button, Row, Col, Image } from 'react-bootstrap';
import { useCollectionData } from 'react-firebase-hooks/firestore';
import { TextInput } from 'evergreen-ui';
import firebase from 'firebase';
import 'firebase/firestore';
import uuid from 'uuid/v4';

import './headline.scss';
import moment from 'moment';

const initialState = {
    id: "",
    title: "",
    subtitle: "",
    info: "",
    created: null,
};

const headlineReducer = (state, action) => {
    switch (action.type) {
        case 'UPDATE_TITLE':
            return { ...state, title: action.title };
        case 'UPDATE_SUBTITLE':
            return { ...state, subtitle: action.subtitle };
        case 'UPDATE_INFO':
            return { ...state, info: action.info };
        case 'SEND_HEADLINE':
            return initialState;
        default:
            return state;
    }
}

export default function Headline(props) {

    const headlineRef = firebase.firestore().collection('headline');
    const [headline, dispatch] = useReducer(headlineReducer, initialState);
    const [headlineData, loading, error] = useCollectionData(headlineRef.orderBy('created', 'desc'), {
        snapshotListenOptions: { includeMetadataChanges: true }
    });

    const sendHeadline = (e) => {
        console.log('sending headline');
        e.preventDefault();
        try {
            const id = uuid();
            headlineRef.doc(id).set({
                id: id,
                title: headline.title,
                subtitle: headline.subtitle,
                info: headline.info,
                created: Date.now(),
            });
            console.log('headline sent to firebase');
            dispatch({ type: 'SEND_HEADLINE' });
        } catch (error) {
            console.log("error uploading headline : ", error);
        }
    }

    const deleteHeadline = (id) => {
        try {
            headlineRef.doc(id).delete();
        } catch (error) {
            console.log('erreur de suppression');
        }
    }

    const updateTitle = (event) => dispatch({ type: 'UPDATE_TITLE', title: event.target.value });
    const updateSubtitle = (event) => dispatch({ type: 'UPDATE_SUBTITLE', subtitle: event.target.value });
    const updateInfo = (event) => dispatch({ type: 'UPDATE_INFO', info: event.target.value });


    return (
        <Modal show={props.show} onHide={props.close} className="editor-modal">
            <Modal.Header>
                <Modal.Title>Headline</Modal.Title>
            </Modal.Header>

            <Modal.Body className="root">
                <Row>
                    <TextInput
                        name="title-input"
                        className="title-input"
                        placeholder="Titre"
                        onChange={updateTitle}
                        value={headline.title}
                    />
                    <TextInput
                        name="subtitle-input"
                        className="title-input"
                        placeholder="Sous-titre"
                        onChange={updateSubtitle}
                        value={headline.subtitle}
                    />
                    <TextInput
                        name="info-input"
                        className="title-input"
                        placeholder="Information"
                        onChange={updateInfo}
                        value={headline.info}
                    />
                </Row>
                <Row>
                    <Button variant="light" onClick={sendHeadline}>Mettre en ligne</Button>
                    <Button variant="warning" onClick={props.close}>Fermer</Button>
                </Row>
                {error && <p>Erreur de chargement</p>}
                {loading && <p>Chargement</p>}
                {headlineData &&
                    headlineData.map(doc => {

                        const { title, subtitle, info, created, id } = doc;

                        return (
                            <Row className="headline-list" key={id}>
                                <Col xs={10}>
                                    <p>{title} - {subtitle} - {info} - {moment(created).format('DD/MM')}</p>
                                </Col>
                                <Col xs={2} style={{ alignItems: 'center' }}>
                                    <Button variant="outline-danger" onClick={() => deleteHeadline(id)}>Supprimer</Button>
                                </Col>
                            </Row>
                        )
                    })
                }
            </Modal.Body>
        </Modal>
    )
}